import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_option_field = _resolveComponent("option-field")
  const _component_text_field = _resolveComponent("text-field")

  return ($options.isProductOptionTypeList)
    ? (_openBlock(), _createBlock(_component_option_field, {
        key: 0,
        modelValue: _ctx.model,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.model) = $event)),
        "display-name": $props.option.text,
        options: $options.getOptions($props.option),
        class: _normalizeClass(['gfu-field-select--primary', $props.fieldClass]),
        "show-placeholder": true,
        name: "model",
        "show-label": $props.showLabel,
        "label-class": $props.labelClass,
        inline: $props.inline,
        small: $props.small,
        "no-option-capitalize": true,
        disabled: $props.disabled,
        onChange: $options.onChange,
        "data-qa": 'product-option-field:' + $props.option.text
      }, null, 8 /* PROPS */, ["modelValue", "display-name", "options", "class", "show-label", "label-class", "inline", "small", "disabled", "onChange", "data-qa"]))
    : (_openBlock(), _createBlock(_component_text_field, {
        key: 1,
        modelValue: _ctx.customText,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.customText) = $event)),
        "display-name": $props.option.text,
        class: _normalizeClass(['gfu-field-input--primary', $props.fieldClass]),
        "show-label": $props.showLabel,
        "label-class": $props.labelClass,
        inline: $props.inline,
        small: $props.small,
        disabled: $props.disabled,
        name: "customText",
        maxlength: $props.option.maxCustomTextLength,
        placeholder: _ctx.Resources.Product.CustomTextOptionPlaceholder,
        "on-change": $options.onCustomTextChange,
        "data-qa": 'product-custom-text-option:' + $props.option.text
      }, null, 8 /* PROPS */, ["modelValue", "display-name", "class", "show-label", "label-class", "inline", "small", "disabled", "maxlength", "placeholder", "on-change", "data-qa"]))
}